<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Add/Edit Production Activity</h4>
    <div class="content-block">To add new, if the ID field does not show “Select…”, click the X after the ID that is
        displaying, type a name in the Name field and notes, (optional), then click the Save button</div>

    <div class="content-block">
        <form class="login-form" (submit)="handleSubmit($event)">

            <dx-form id="form" [colCount]="6" [(formData)]="productionactivity">
                <dxi-item dataField="productionActivityId" [colSpan]="2">
                    <dx-select-box #selectBox [items]="productionactivities"
                        (onValueChanged)="onProductionActivityChange($event)" searchEnabled="true"
                        showClearButton="true" displayExpr="productionActivityName"
                        [(value)]="productionactivity.productionActivityId" valueExpr="productionActivityId">
                    </dx-select-box>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                <dxi-item dataField="productionActivityName" editorType="dxTextBox" [colSpan]="2"
                    [editorOptions]="{ value:selectBox.text ? selectBox.text: '' }">
                    <dxi-validation-rule type="required" message="Production Activity is required">
                    </dxi-validation-rule>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                <dxi-item dataField="note" editorType="dxTextArea" [colSpan]="2">

                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                <dxi-item itemType="button" [colSpan]="2"
                    [buttonOptions]="{ text: 'Save', type:'success', useSubmitBehavior: true }">
                </dxi-item>
            </dx-form>
        </form>
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>